import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInviteColleagues = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 200 200",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.63,
			d: "M519.407 332.772c-3.859 3.972-1.25 13.728 5.36 10.109 5.478-3-1.891-16.172-6.694-11.831-2.555 2.308-1.321 6.189 1.785 4.272 1.071-.661 5.07-4.817 1.015-5.065",
			transform: "matrix(1.12805 0 0 1.32411 -540.621 -377.608)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M45.399 84.024c-2-.046-3.034 3.93-3.257 5.904-.481 4.25-.59 8.477-.59 12.757 0 12.048 2.84 24.128 3.12 36.16.05 2.157-.258 14.483 2.023 14.15 3.692-.541 13.964.867 13.964-2.235 0-1.815-3.796-.484-3.77-.953.408-7 2.822-16.934.584-29.937"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M44.725 94.764c.17 2.812 2.626 19.488 8.456 23.237.715.46 3.768-1.8 3.622-2.995 0 0-2.505-2.702-3.605-11.426"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0028852,
			d: "M54.368 117.981c0 .234-.066.636.03.833.321.636 1.542 1.01 2.163 1.046.205.007.746.146.921.007 1.221-.987 1.638-3.173-.204-3.699-.19-.051-.468-.212-.673-.212M81.273 119.218c-.165.166-.494.406-.565.613-.218.679.389 1.802.805 2.264.14.15.428.628.65.652 1.563.156 3.395-1.107 2.454-2.775-.1-.17-.184-.48-.33-.624"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M45.399 84.024c2.83-.307 4.388-.37 6.226.873 2.197 1.487 4.106 4.598 4.832 6.982 2.853 9.356 1.493 15.974 1.493 24.623"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.72,
			d: "M551.664 332.737c-2.1 4.362 1.583 11.954 7.166 10.144 4.316-1.4 4.928-10.81 2.357-13.06-2.551-2.233-3.2 2.151-2.16 3.538.905 1.207 8.565 3.409 5.431 6.151-1.296 1.135-.469-3.417-.818-5.104-.693-3.351-2.937-6-6.446-6.381-9.265-1.007-5.993 8.448.785 6.021",
			transform: "matrix(1.02324 0 0 1.28221 -475.96 -363.981)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M91.978 81.84c17.364 3.663 32.284-1.835 33.848-1.053.943.47-2.386 6.298-2.772 6.758-3.626 4.304-15.003 5.655-20.303 6.412"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M91.978 81.84c-8.296-3.195-12.34 25.613-11.097 36.222.24 2.041 1.823.11 2.684.741 3.483 2.546 4.088-18.21 4.539-17.76 1.932 1.932-.656 15.34-.623 17.742.104 7.285-.028 27.838 1.49 31.238.393.883 8.469 3.032 13.127.761 2.642-1.288 4.488-13.561 4.534-16.878.173-12.444 1.699-27.514-3.881-39.949"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M89.158 150.173c-1.142-1.245.953-5.68 2.656-5.81 1.205-.092 5.139 5.896 3.9 6.515-.366.184 1.3-4.908 3.954-4.993 3.462-.111 3.58 2.803 2.43 4.9M129.427 43.233c3.92.482 17.644 2.872 21.822 3.844 1.076.25 4.884.432 5.242 1.863 1.971 7.888.565 17.316.694 25.348.278 17.52.303 35.032.303 52.555 0 6.128-.056 12.248.216 18.37.058 1.292 1.207 5.226.52 6.37-.658 1.096-8.739 1.746-9.835 1.906-7.385 1.077-10.947 1.903-16.824 3.276"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M129.427 43.233c-.725 5.407 1.151 17.24 1.5 23.689.873 16.056 1.42 32.103 1.734 48.18.23 11.798-3.876 30.55-1.096 41.663M136.518 96.083c-.908 3.203 2.185 4.447 2.556 1.514.325-2.58-2.218-2.153-2.556-1.514"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9994060999999999,
			d: "M129.262 51.537c1.054-.286-11.933.257-11.94.307-1.006 9.057 2.755 19.933 2.68 29.374M120.114 89.764c.39 7.479.455 16.015.545 17.278.89 12.45.242 29.043.424 39.84.005.323 9.514.143 9.514-.238"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0028852,
			d: "M55.04 152.586c0-.483.045-1.323 0-1.813-.328-3.406-3.574-1.988-3.625-2.069-.183-.3-.307-18.603-.307-19.597M95.799 148.734s1.995-13.494 1.571-22.098"
		})
	]
});
export default SvgInviteColleagues;
